// extracted by mini-css-extract-plugin
module.exports = {"knowledge-hub-search-wrapper":"knowledge-hub-search-wrapper__VErv7","close-button":"close-button__GoVDs","mobile":"mobile__ZTSHy","desktop":"desktop__eQgHN"};